import { formatDistanceStrict } from 'date-fns';
import { Bell } from 'lucide-react';
import { Comment } from "types/api/tasks";

interface Props {
    details: Comment | Partial<Comment>;
}

export const Update = ({ details }: Props) => {
    return (
        <div className="flex text-xs tracking-normal gap-2 items-center justify-center bg-gray-50 dark:bg-card min-h-10 rounded-xl p-2 pr-2.5 ">
            <Bell size={16} className='text-textcolor' />
            <span className="flex-1 leading-none font-medium text-textcolor" dangerouslySetInnerHTML={{ __html: details.comments ?? '' }}></span>
            <div className='text-xs text-gray-400'>{formatDistanceStrict(new Date(details.updated_at ?? ''), new Date(), { addSuffix: true })}</div>
        </div>);
}